import Debug from "@/react/debug";

export const addressValidation = async ({
  freeformAddress,
  selectedCountry,
  validateFreeform,
  validateAddress,
  searchAddress,
  createAddress,
  setErrorMessage,
  setFreeformAddress,
  setValidAddress,
}) => {
  let finalAddress = null;

  try {
    // Step 1: Freeform validation
    const freeformResponse = await validateFreeform({
      freeForm: freeformAddress,
      country: selectedCountry?.value,
    });

    const suggestedAddress =
      freeformResponse.data?.success?.[0]?.resultPayload?.suggestedAddress;

    if (!suggestedAddress) {
      const errorMsg =
        freeformResponse.error?.data?.failed?.[0]?.resultPayload?.description ||
        "Address could not be validated.";
      throw new Error(errorMsg);
    }

    finalAddress = suggestedAddress;

    // Step 2: Address validation
    const validationResponse = await validateAddress({ address: finalAddress });
    const validatedAddress = validationResponse?.data?.[0]?.address;

    if (!validatedAddress) {
      const errorMsg =
        validationResponse.error?.data?.errors?.[0]?.message ||
        "Address could not be validated.";
      throw new Error(errorMsg);
    }

    finalAddress = validatedAddress;
    setFreeformAddress(validatedAddress.displayForm);

    // Step 3: Search address, fallback to create if 404
    let foundAddress = await searchAddress({
      address: finalAddress,
    });

    if (foundAddress?.error?.status === 404) {
      foundAddress = await createAddress({ address: finalAddress });
    }

    // Step 4: Final result
    // foundAddress.isSuccess is expected for /searchResponse
    // foundAddress.data is expected for /create endpoint
    if (foundAddress.isSuccess || foundAddress.data) {
      setValidAddress(foundAddress.data);
      setErrorMessage("");
    } else {
      const errorMsg =
        foundAddress.error?.data?.errors?.[0]?.message ||
        "Address could not be found or created.";
      throw new Error(errorMsg);
    }
  } catch (error) {
    Debug.error(error);
    const errorMsg = error?.message || "An unexpected error occurred.";
    setErrorMessage(errorMsg);
  }
};
